async function handleDefaultCrossSell(){
    setButtonLoadDots('crsBuyButton', 3000)
    const url = 'https://www.caffeinearmy.com.br/cart/add.js';
    const productItems= formatProductList('default')

    await clearCart()

    await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({items: productItems}),
      }).then(response => {
        setTimeout(() =>  window.location.href='/checkout', 400)
      }).catch((error) => {
        console.error('Error:', error);
      });
  
}


async function handlePrimeCrossSell(planConfig){
  setButtonLoadDots('crsPrimeButton', 4000)
  const productItems= formatProductList('prime')

  const primeCheckoutURL = await handleCreatePrimeCheckout(productItems, planConfig)

  if(primeCheckoutURL){
    return window.location.href = `${primeCheckoutURL}`
  }
    
}

function formatProductList(variant){
  const productItems= []
  const selectedVariantsIds = document.querySelectorAll('.crs-product-variant');
  if(selectedVariantsIds){
      selectedVariantsIds.forEach((productInfo, i) => {
         if(productInfo.value){
          const stringSplitIndex = variant === 'prime' ? 0 : 1
          const variantIdentifier = productInfo.value.split('--')[stringSplitIndex]
          const productItem ={quantity: 1}

          if(variant === 'prime'){
            productItem.cycles = 12
            productItem.currentProduct = variantIdentifier;
          }else{
            productItem.id = variantIdentifier
          }
          
          productItems.push(productItem)
         }
      })
  }

  return productItems
}